interface AppConfig {
  apiBaseUrl: string
  whisperApiUrl: string
  whisperWsUrl: string
  firebaseApiKey: string
  firebaseAuthDomain: string
  firebaseProjectId: string
  firebaseStorageBucket: string
  firebaseMessagingSenderId: string
  firebaseAppId: string
  useFirebaseEmulator: boolean
  firebaseEmulatorUrl: string
  sentryDsn: string
  sentryRelease: string
  e2eBypassMfa: boolean
  /** Keycloak's public URL; empty means the one derived from the hostname (`getKeycloakUrl`). */
  keycloakUrl: string
}

declare global {
  interface Window {
    __CONFIG__?: Partial<AppConfig>
  }
}

function get(key: keyof AppConfig, fallbackEnvKey: string): string {
  return (window.__CONFIG__?.[key] as string) || import.meta.env[fallbackEnvKey] || ''
}

export const config: AppConfig = {
  apiBaseUrl: get('apiBaseUrl', 'VITE_API_BASE_URL') || 'http://localhost:8080',
  whisperApiUrl: get('whisperApiUrl', 'VITE_WHISPER_API_URL') || 'http://localhost:8000',
  whisperWsUrl: get('whisperWsUrl', 'VITE_WHISPER_WS_URL') || 'ws://localhost:8000',
  firebaseApiKey: get('firebaseApiKey', 'VITE_FIREBASE_API_KEY'),
  firebaseAuthDomain: get('firebaseAuthDomain', 'VITE_FIREBASE_AUTH_DOMAIN'),
  firebaseProjectId: get('firebaseProjectId', 'VITE_FIREBASE_PROJECT_ID'),
  firebaseStorageBucket: get('firebaseStorageBucket', 'VITE_FIREBASE_STORAGE_BUCKET'),
  firebaseMessagingSenderId: get('firebaseMessagingSenderId', 'VITE_FIREBASE_MESSAGING_SENDER_ID'),
  firebaseAppId: get('firebaseAppId', 'VITE_FIREBASE_APP_ID'),
  useFirebaseEmulator:
    (window.__CONFIG__?.useFirebaseEmulator ?? import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true'),
  firebaseEmulatorUrl: get('firebaseEmulatorUrl', 'VITE_FIREBASE_EMULATOR_URL') || 'http://localhost:9099',
  sentryDsn: get('sentryDsn', 'VITE_SENTRY_DSN'),
  sentryRelease: get('sentryRelease', 'VITE_SENTRY_RELEASE'),
  e2eBypassMfa: window.__CONFIG__?.e2eBypassMfa === true,
  keycloakUrl: get('keycloakUrl', 'VITE_KEYCLOAK_URL'),
}
